import { paginationItemClasses } from '@mui/material/PaginationItem'
import { CssVarsThemeOptions, alpha } from '@mui/material/styles'

// ----------------------------------------------------------------------

const COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'] as const

// NEW VARIANT
declare module '@mui/material/Pagination' {
	interface PaginationPropsVariantOverrides {
		soft: true
	}

	interface PaginationPropsColorOverrides {
		info: true
		success: true
		warning: true
		error: true
	}
}

// ----------------------------------------------------------------------

export function pagination(): CssVarsThemeOptions['components'] {
	return {
		MuiPagination: {
			styleOverrides: {
				root: ({ ownerState, theme }) => {
					const defaultColor = ownerState.color === 'standard'

					const filledVariant = ownerState.variant === 'text'

					const outlinedVariant = ownerState.variant === 'outlined'

					const softVariant = ownerState.variant === 'soft'

					const defaultStyle = {
						[`& .${paginationItemClasses.root}`]: {
							...(outlinedVariant && {
								borderColor: alpha(theme.palette.grey[500], 0.24),
							}),

							[`&.${paginationItemClasses.selected}`]: {
								fontWeight: theme.typography.fontWeightSemiBold,
								...(outlinedVariant && {
									borderColor: 'currentColor',
								}),

								...(defaultColor && {
									backgroundColor: alpha(theme.palette.grey[500], 0.08),
									...(filledVariant && {
										color: theme.palette.common.white,
										backgroundColor: theme.palette.text.primary,
										'&:hover': {
											backgroundColor: theme.palette.grey[700],
										},
									}),
								}),
							},
						},
					}

					const colorStyle = COLORS.map((color) => ({
						...(ownerState.color === color && {
							[`& .${paginationItemClasses.root}`]: {
								[`&.${paginationItemClasses.selected}`]: {
									...(ownerState.color === color && {
										// SOFT
										...(softVariant && {
											color: theme.palette[color]['dark'],
											backgroundColor: alpha(theme.palette[color].main, 0.08),
											'&:hover': {
												backgroundColor: alpha(theme.palette[color].main, 0.16),
											},
										}),
									}),
								},
							},
						}),
					}))

					return [defaultStyle, ...colorStyle]
				},
			},
		},
	}
}
